import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CaseModel } from 'src/app/models/case.model';
import { Config } from 'src/app/models/config.model';
import { Tab } from 'src/app/models/tab.model';
import { CaseService } from 'src/app/services/case.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-case-events',
  templateUrl: './case-events.component.html',
  styleUrls: ['./case-events.component.scss']
})
export class CaseEventsComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  config!: Config;

  tabs: Tab[] = [
    { title: 'Hendelser', active: true },
    { title: 'Alle sakens dokumenter', active: false }
  ];

  caseCount: number[] = [0, 0]; //same order as tabs

  constructor(private configService: ConfigService, private caseService: CaseService) { 

    this.caseService.currentCase
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(
      (value: CaseModel | null ) => {
        if (value !== null) {
          let docCount:number = value.Events.reduce((acc,element) => acc + element.Documents.length, 0);
          this.caseCount = [value.Events.length, docCount];  
        }
      }
    );
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  setActiveTab(tabIndex: number): void {
    this.tabs[tabIndex].active = true;
    this.tabs.forEach(
      (tab: Tab, index: number) => {
        if (index !== tabIndex) {
          tab.active = false;
        }
      }
    );
  }
}
